<template>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="rubro" class="block text-sm font-medium text-gray-700">Rubro</label>
      <input type="text" id="rubro" :value="loadData.rubro"
             @change="(newRubro)=>$emit('updateValues', {'rubro': newRubro.target.value, 'fuente_concreta_id': ''})"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="nombre" class="block text-sm font-medium text-gray-700">Nombre del rubro</label>
      <textarea id="nombre" :value="loadData.nombre"
                @change="(newNombreRubro)=>$emit('updateValues', {'nombre': newNombreRubro.target.value})"
                rows="4"
                class="block p-2.5 w-full text-sm rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RubrosCrearActualizarComponent',
  props: ['loadData', 'collectionFuentesConcretas'],
  emits: ["updateValues"],
}
</script>